import React, { HTMLAttributes } from 'react'

const SJSpace: React.FC<HTMLAttributes<HTMLDivElement> & { width?: number; height?: number }> = ({
  width,
  height = 0,
}) => {
  return <div style={{ width: width ? width + 'px' : '100%', height: height + 'px' }}></div>
}

export default SJSpace
